import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import NewSectionForm from 'core/modules/components/forms/NewSectionForm';

function getTitle({ t, dataEdit, isRename }) {
  if (!dataEdit?.guid) return t('new-lesson:Add new section');
  return isRename ? t('new-lesson:Rename section') : t('new-lesson:Edit section');
}

// `isRename` solo lo activa la lección Power, cuyo menú de sección dice «Renombrar» (TAN-10441): al
// renombrar una sección existente solo cambia el nombre, así que el formulario oculta el tipo. Crear
// (también con `isRename`) y editar en las vistas legacy siguen ofreciéndolo.
function DialogNewSection({ dataEdit, isPublisherMode, isRename = false, lesson, onClose = function () {}, onSuccess = function () {}, open = false, t }) {
  const isRenamingSection = isRename && !!dataEdit?.guid;

  return (
    <Dialog title={getTitle({ t, dataEdit, isRename })} isOpen={open} className={'dialog-new-lesson'} onClose={onClose} size="s">
      <NewSectionForm
        onCancel={onClose}
        onSuccess={onSuccess}
        dataEdit={dataEdit}
        isPublisherMode={isPublisherMode}
        lesson={lesson}
        shouldHideType={isRenamingSection}
      />
    </Dialog>
  );
}

DialogNewSection.propTypes = {
  t: PropTypes.func,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  open: PropTypes.bool,
  dataEdit: PropTypes.object,
  isPublisherMode: PropTypes.bool,
  isRename: PropTypes.bool,
  lesson: PropTypes.object,
};

export default withTranslation(['new-lesson'])(DialogNewSection);
